import { Routes } from "@angular/router";
import { ConfirmRequestComponent } from "./components/confirm-request/confirm-request.component";
import { StartComponent } from "./components/start/start.component";
import { MapComponent } from "./components/map/map.component";
import { AuthenticationGuard } from "./guards/authentication.guard";

export const routes: Routes = [
  { path: "", component: StartComponent },
  { path: "start", component: StartComponent },
  { path: "start/:code/:state", component: StartComponent },
  {
    path: "confirm-request/:application/:token",
    component: ConfirmRequestComponent,
  },
  { path: "map", component: MapComponent, canActivate: [AuthenticationGuard] },
];
